import { ATTACHMENT_POLICY } from '@pulse/shared';

const MAX_ATTACHMENT_MB = ATTACHMENT_POLICY.maxFileSizeBytes / (1024 * 1024);

// Shared by AttachmentsPanel.tsx and StagedAttachmentsPanel.tsx for their attachment-list rows,
// and by validateAttachmentSize below for its error message — lives here (rather than on either
// component) so neither has to import from the other.
export function formatSize(bytes: number): string {
  if (bytes < 1024) return `${bytes} B`;
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(0)} KB`;
  return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
}

// Single source of truth for the "reject an oversized attachment before upload" UX — reuse this
// everywhere instead of re-deriving the message format or the size cap per call site. Returns an
// inline error string (e.g. "108.3 MB — max is 10 MB") if `file` exceeds
// ATTACHMENT_POLICY.maxFileSizeBytes, or null when the file is within limits.
export function validateAttachmentSize(file: File): string | null {
  if (file.size <= ATTACHMENT_POLICY.maxFileSizeBytes) return null;
  return `${formatSize(file.size)} — max is ${MAX_ATTACHMENT_MB} MB`;
}
